import { render, staticRenderFns } from "./BaseNavItem.vue?vue&type=template&id=986a84bc&scoped=true"
import script from "./BaseNavItem.vue?vue&type=script&lang=js"
export * from "./BaseNavItem.vue?vue&type=script&lang=js"
import style0 from "./BaseNavItem.vue?vue&type=style&index=0&id=986a84bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986a84bc",
  null
  
)

export default component.exports